import React, { Component, Fragment } from 'react'
import { inject, observer } from 'mobx-react'
import { Header, Image } from 'semantic-ui-react'
import cn from 'classnames'
import Divider from '@ui/Divider'
import Note from './Note'
import { QUESTIONS_COMPONENTS } from './constants'
import ExtraInfo from './ExtraInfo'
import UIQuestion from '@ui/Question'

@inject('surveyState', 'appState')
@observer
export default class Question extends Component {
  onPartial = (value = null) => {
    const { surveyState } = this.props
    surveyState.currentQuestion.saveAnswer(value)
  }

  onPartialNotes = async (value = null) =>
    this.props.surveyState.savePartialNoteAnswer(value)

  render() {
    const { mapped, surveyState, inactive, bordered, appState } = this.props
    const Component = QUESTIONS_COMPONENTS[mapped.type]
    const textDirection = appState.getTextDirection(surveyState.language_code)
    return (
      <UIQuestion
        header={{
          title: surveyState.renderTokens(mapped.moduleTitle),
          description: surveyState.renderTokens(mapped.moduleDescription)
        }}
        topContent={
          <Fragment>
            {surveyState.showExtraInfo && mapped.isQuestion && (
              <ExtraInfo name={mapped.codename} value={mapped.visibleIf} />
            )}
            {mapped.hasCompanyLogo && surveyState.hasBrandLogo && (
              <div className='logo-wrapper'>
                <Image src={surveyState.brandLogo} />
              </div>
            )}
          </Fragment>
        }
        title={surveyState.renderTokens(mapped.title)}
        description={surveyState.renderTokens(mapped.description)}
        bottomContent={
          <Fragment>
            {mapped.hasNotes && (
              <Fragment>
                <Divider hidden />
                <Note mapped={mapped} onPartial={this.onPartialNotes} />
              </Fragment>
            )}
            {mapped.hasHelpText && (
              <Fragment>
                <Divider hidden className='hide-on-desktop' />
                <Header as='h3'>
                  <Header.Subheader>
                    {surveyState.renderTokens(mapped.helpText)}
                  </Header.Subheader>
                </Header>
              </Fragment>
            )}
          </Fragment>
        }
        className={cn({ bordered })}
        textDirection={textDirection}
      >
        {Component ? (
          <Component
            mapped={mapped}
            onPartial={this.onPartial}
            inactive={inactive}
          />
        ) : null}
      </UIQuestion>
    )
  }
}
